import { StatusOptions } from './components/ToastItem/ToastItem.types';

type KeyOfType = 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR' | 'DEFAULT';

export const STATUS: { [key in KeyOfType]: StatusOptions } = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'info',
};

export const SUCCESS_AUTO_CLOSE_TIME = 7000;
